module.exports = __webpack_public_path__ + "img/credit-card-chip.a93e05a8.png";